import { ExposedValueSettingsDialog } from "@/core/components/exposed-values/ExposedValueSettingsDialog";
import type {
  Area,
  ExposedValueDefinition,
  ExposedValueMapping,
  Line,
  LocationScope,
  RealTimeValue,
  Station,
} from "@/modules/energy/types";

interface EnergySettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  exposedValues: ExposedValueDefinition[];
  factoryScope: LocationScope;
  areas: Area[];
  lines: Line[];
  stations: Station[];
  hasDatapoints: boolean;
  realTimeValues: Record<string, RealTimeValue>;
  getMappingForScope: (scope: LocationScope, exposedValueId: string) => ExposedValueMapping | null;
  onSelectMapping: (scope: LocationScope, definition: ExposedValueDefinition) => void;
  onOpenChart: (mapping: ExposedValueMapping) => void;
}

export const EnergySettingsDialog = (props: EnergySettingsDialogProps) => (
  <ExposedValueSettingsDialog
    translationPrefix="mod_energy.energy_management"
    titleFallback="Energy Settings"
    descriptionFallback="Understand exposed values and manage mapping coverage across the factory."
    {...props}
  />
);
